import * as R from 'ramda';
import { createSelector } from 'reselect';

import EntityType from '../../utils/entityType';
import { AppState } from '../reducer';
import { LoadingState } from './reducer';

export const loadingState$ = (state: AppState) => R.pathOr({}, ['loading'], state);

export const loadingOrders$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, [`@@${EntityType.ORDERS}`], state)
);

export const loadingProfile$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, [`@@${EntityType.PROFILE}`], state)
);

export const loadingSuppliers$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, [`@@${EntityType.SUPPLIERS}`], state)
);

export const loadingServiceAreas$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, [`@@${EntityType.SERVICE_AREAS}`], state)
);

export const loadingAvailability$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, ['@@availability'], state)
);

export const loadingReferrer$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, ['@@referrer'], state)
);

export const loadingCatalogue$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, [`@@${EntityType.CATALOGUES}`], state)
);

export const loadingCartCatalogue$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, ['@@cart'], state)
);

export const loadingPricing$ = createSelector([loadingState$], (state: LoadingState) =>
  R.pathOr(false, ['@@pricing'], state)
);
